<div class="col-12">
  <div class="row" style="height: 30px;">
      <div class="col-12" style="border-bottom: 1px solid #ccc"></div>
  </div>
  <div class="row">
      <div class="col-12" style="font-size: medium">
        {{config.name}}
      </div>
  </div>
  <div class="row" style="height: 20px">
    <div class="col-12"></div>
  </div>
</div> 